import Label from 'components/general/Label';
import { ColumnName, ColumnRank, ColumnNoc, ColumnMove, ColumnIrmOrValue, ColumnResult, ColumnExtendedResult, ColumnQualification } from "components/common/TableColumns"
import Competitor from 'components/presentation/Competitor';
import { usePositions } from 'components/common/Positions';
import { NocMemo as Noc} from 'components/presentation/Noc';
import SportCode from 'components/common/SportCode';


export function ColumnRankRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Rank',
        headerClassName: "text-end w-5 text-nowrap align-middle",
        id: 'HeaderRank',
        columns: [
          ColumnRank({remove: true, disableSort: true})
        ]
      }
}

export function ColumnExtendedResultRowSpan({id = "er", label = "none", code = ""}) {
  return {
      Header: "-",
      enableRowSpan: true,
      relatedId: id,
      headerClassName: "text-end w-5 align-middle",
      id: 'Header'+ id,
      columns: [
        ColumnExtendedResult({remove: true, id: id, label: label, code: code})
      ]
    }
}

export function ColumnResultRowSpan() {
  return {
      Header: "-",
      enableRowSpan: true,
      relatedId: 'Result',
      headerClassName: "text-end w-5 align-middle",
      id: 'HeaderResult',
      columns: [
        ColumnResult({remove: true, disableSort: true, label: 'HeaderNetPointsAbbrv'})
      ]
    }
}

export function ColumnQualificationRowSpan({headerClassName='text-end w-5', className="text-end fw-bold"}) {
  return {
      Header: "-",
      enableRowSpan: true,
      relatedId: 'QualMark',
      headerClassName: headerClassName + " align-middle",
      id: 'HeaderQualMark',
      columns: [
        ColumnQualification({remove: true, className: className, headerClassName: headerClassName})
      ]
    }
}


export function ColumnMoveRowSpan({currentLeg = '-'}) {
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'Move',
    headerClassName: "text-center w-5' align-middle",
    id: 'HeaderMove',
    columns: [
      ColumnMove({remove: true, disableSort: true, currentLeg: currentLeg, type: 'extendedResultsSAL'})
    ]
  }

}



export function ColumnNocRowSpan() {
  return {
      Header: "-",
      enableRowSpan: true,
      relatedId: 'NOC',
      headerClassName: "text-start d-none d-md-table-cell w-5 align-middle",
      id: 'HeaderNOC',
      columns: [
        ColumnNoc({remove: true, disableSort: true})
      ]
    }
}

export function ColumnNameRowSpan({type = 'A', headerClassName="text-start align-middle"}) {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Name',
        headerClassName: headerClassName,
        id: 'HeaderBoat',
        label: "HeaderBoat",
        columns: type === 'T' ? [ColumnCrew()] : [ColumnName({remove: true, label: "HeaderBoat", disableSort: true})] 
      }
}

export function ColumnCrew(remove=true){
  return {
    id: 'Name',
    Header: <Label data="HeaderBoat" />,
    headerClassName: "text-start ",
    className: 'text-start ',
    remove: remove,
    disableSort: true,
    Cell: (props) => {
      const row = props.cell.row.original;
      return <>
            <div className="d-md-none">
              <Noc {...row?.participant?.organisation} showOnlyImage={true}/>
            </div>
            <Crew athletes={row?.teamAthletes} />
        </>;
    }
  }

}

const Crew = ({athletes}) => {
  const positions = usePositions();
  let out =  athletes?.sort((a,b) =>  a?.order - b?.order)?.map(ath => {
    
    //patch for CUMULATIVE query due to it does NOT has the same structure as RESULT quey
    ath.athlete = ath?.participantCode ? ath?.participantCode : ath?.athlete;
    ath.eventUnitEntries = ath?.participantCode && !ath?.eventUnitEntries ? [{eue_code: "POSITION", eue_value:(ath?.order ==1 ? 'H' : 'C')}] : ath.eventUnitEntries;

     return (<div key={ath?.athlete?.code} className='d-flex'>
                  <Competitor {...ath.athlete} hidePicture={true} hideNoc={true} />
                  <div  className="d-none d-md-block">&nbsp;-&nbsp;{positions(ath?.eventUnitEntries?.find(item => item?.eue_code === 'POSITION')?.eue_value)}</div>
              </div>);
  })
  return <>{out}</>
}

export function ColumnMarksColspan({marks = []}){
    return {
        id: 'HeaderMarks',
        Header: <Label data="HeaderMarks" />,
        headerClassName: "text-center",
        columns: [ ...getColumnMark(marks)]
      }
}

export function ColumnRacesColspan({races = [], isMedalSeries, headerClassName = "text-end w-5"}){
  return {
      id: 'HeaderRaces',
      Header: <Label data={isMedalSeries ? 'HeaderMedalSeries' : 'HeaderPointsRace'} />,
      headerClassName: "text-center",
      columns: [ ...getColumnRace(races, headerClassName)]
    }
}

function getColumnMark(marks){
  return marks?.map(m => (
          {
              id: 'Mark' + m?.ei_pos,
              Header: m?.ei_value === 'F' ? <Label data={'HeaderFinish'} /> : m?.ei_value,
              headerClassName: "text-end",
              className: 'text-end w-5',
              Cell: (props) => {
                  
                  const res = props.cell.row.original?.extendedResults?.find(er => er?.er_code === 'MARK' && er?.er_pos === m?.ei_pos);
                  const rank = res?.er_rank && res?.er_rankequal === 'Y' ? `=${res?.er_rank}` : res?.er_rank ? res?.er_rank : '';
                  const time = rank === '1' ? res?.er_value : res?.er_diff ? `+${res?.er_diff}` : '' 

                  return (<>
                       <div className="text-end">{rank}</div>
                       <div className="text-end">{time}</div>
                      </>
                  );
              }
          }
      ))
}

function getColumnRace(races, headerClassName = "text-end w-5"){
  return races?.map(race => (
          {
              id: 'Race' + race?.pos,
              Header: race?.value === 'MARATHON' ? <Label data="HeaderMarathon" /> : <>{race?.value}</>,
              headerClassName: headerClassName,
              className: 'text-end',
              Cell: (props) => {
                  const row = props.cell.row.original;                  
                  const res = row?.items?.find(i => i?.eventUnit?.code === race?.unit);
                  const irm = res?.irm ? <SportCode discipline="SAL" entity='@IRM' code={res?.irm} abbr={true}/> : <></>
                  const discarded = res?.extendedResults?.find(er => er?.er_code === 'DISCARDED')?.er_value === 'Y'
                  return (<>
                       <div className={`text-end ${discarded ? 'text-decoration-line-through' : ''}`} >{res?.resValue}</div>
                       {irm && <div className={`text-end ${discarded ? 'text-decoration-line-through' : ''}`} >{irm}</div>}
                      </>
                  );
              }
          }
      ))
}

export function ColumnRacePointsRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'resultData',
        headerClassName: "text-end w-5 align-middle",
        id: 'HeaderRacePoints',
        columns: [
          ColumnIrmOrValue({id:'resultData', label: 'HeaderRacePoints', remove: true,})
        ]
      }
}

export function ColumnEstOverallRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'EstOverall',
        headerClassName: "text-end align-middle",
        id: 'HeaderEstOverall',
        columns: [
            ColumnEstOverall({})
        ]
      }
}

function ColumnEstOverall() {
    return {
        id: 'EstOverall',
        Header: <Label data="HeaderEstOverallPts" />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        remove: true,
        Cell: (props) => {
          const res = props.cell.row.original?.extendedResults?.find(er => er?.er_type === 'OVERALL' && er?.er_code === 'ESTIMATED')
          return res?.er_value && res?.er_value2 ? `${res?.er_value2} (${res?.er_value})` :  res?.er_value ? `(${res?.er_value})` : res?.er_value2 ?  res?.er_value2 : '';
        }          
          
    }
} 

export function ColumnEr({
  disableSort = true,
  className = 'text-end',
  headerClassName = 'text-end w-10',
  label = 'None',
  id = 'None',
  code= 'None'

}) {
  return (
      {
          Header: <Label data={label} />,
          id: id,
          className: className,
          headerClassName: headerClassName,
          disableSortBy: disableSort,
          Cell: (props) => {
              return getValue(props.cell.row.original, code)
          }
      }
  )
}

function getValue(row, code) {
  const start = row?.extendedResultsCurrent?.find(i => i?.er_code === 'START')
  const leg = row?.extendedResultsCurrent?.find(i => i?.er_code === 'LEG')
  if (code === 'startPosition') {
    return <SportCode discipline="SAL" entity='@Start' code={start?.er_value} />;

  } else if (code === 'startDistance') {
    return start?.er_diff && start?.er_diff !== '0' ? `+${start?.er_diff}` : start?.er_diff;

  } else if (code === 'startSpeed') {
    return start?.er_speed;

  } else if (code === 'timeBehind') {
    return leg?.er_diff && leg?.er_diff !== '0:00' ? `+${leg?.er_diff}` : leg?.er_diff;

  } else if (code === 'distanceBehind') {
    return row?.diff;

  } else if (code === 'speed') {
    return leg?.er_speed;

  }
  
  return '';

}

export function ColumnEarnedWinsRowSpan(phase){
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'Earned',
    headerClassName: "text-start w-5 text-nowrap align-middle",
    id: 'HeaderEarned',
    columns: [
      ColumnEarnedWins({phase: phase})
    ]
  }

}



export function ColumnEarnedWins({phase}){
  return (
    {
        Header: <Label data="HeaderEarnedWins" />,
        id: "Earned",
        className: "text-start",
        headerClassName: "text-start",
        disableSortBy: true,
        remove:true,
        Cell: (props) => {
          let row = props.cell.row.original 
          return row?.extendedResults.find(er => er.er_code === phase)?.er_value 
        }
    }
  )
}

export function ColumnSummaryRankRowSpan(phase){
  return {
    Header: "-",
    enableRowSpan: true,
    relatedId: 'Rank',
    headerClassName: "text-end w-5 text-nowrap align-middle",
    id: 'HeaderRank',
    columns: [
      ColumnSummaryRank({phase: phase})
    ]
  }

}

export function ColumnSummaryRank({phase}){
  return (
    {
        Header: <Label data="HeaderRank" />,
        id: "Rank",
        className: "text-end",
        headerClassName: "text-end",
        disableSortBy: true,
        remove: true,
        accessor: (props) => (props?.extendedResults.find(er => er.er_code === phase)?.er_sortorder ),
        Cell: (props) => {
          let row = props.cell.row.original 
          return row?.extendedResults.find(er => er.er_code === phase)?.er_rank 
        }
    }
  )
}

export function ColumnSumaryRace(rsc, index){
  const label = index+1
  return (
    {
        Header: label,
        id: `race-${index}`,
        className: "text-center",
        headerClassName: "text-center",
        disableSortBy: true,
        Cell: (props) => {
          let row = props.cell.row.original 
          let val = row?.items.find(i => i?.eventUnit?.code === rsc)?.resValue
          return  val
        }
    }
  )
}